export const SHOW_PAGE_TITLE_NOTIFICATION = 'show-page-title-notification';
export const CLEAR_PAGE_TITLE_NOTIFICATION = 'clear-page-title-notification';
export const IFRAME_RESIZE = 'iframe-resize';
export const IFRAME_RESIZE_DRAG_EXPAND = 'iframe-resize-drag-expand';
export const STORE_WIDGET_SIZE_PREFERENCE = 'store-widget-size-preference';
export const OPEN_CHANGE = 'open-change';
export const CLOSED_WELCOME_MESSAGE = 'closed-welcome-message';
export const REQUEST_WIDGET = 'request-widget';
export const STORE_MESSAGES_COOKIE = 'store-messages-cookie';
export const EXTERNAL_API_EVENT = 'external-api-event';
export const START_TRACK_SCROLL_PERCENTAGE = 'start-track-scroll-percentage';
export const STOP_TRACK_SCROLL_PERCENTAGE = 'stop-track-scroll-percentage';
export const START_TRACK_EXIT_INTENT = 'start-track-exit-intent';
export const STOP_TRACK_EXIT_INTENT = 'stop-track-exit-intent';
export const API_REQUEST = 'api-request';
export const I18N_LABELS = 'i18n-labels';
export const REFRESH_WIDGET_DATA = 'refresh-widget-data';
export const SCREEN_CAPTURE_REQUEST = 'screen-capture-request';
export const DRAG_HANDLE_POSITION_CHANGE = 'drag-handle-position-change';
export const SPOTLIGHT_MENU_RESIZE = 'spotlight-menu-resize';
export const LIGHTBOX_OPEN = 'lightbox-open';
export const LIGHTBOX_CLOSE = 'lightbox-close';
export const INPUT_TEXT_CHANGED = 'input-text-changed';
export const RESTORE_SAVED_LAUNCHER_POSITION = 'restore-saved-launcher-position';
export const RESET_TO_DEFAULT_LAUNCHER_POSITION = 'reset-to-default-launcher-position';
export const SPOTLIGHT_LAYOUT_CHANGED = 'spotlight-layout-changed';